import Headline from "./atoms/headline"
import Room from "./atoms/room"

const ROOMS = [
    {
        name: 'Studio',
        equipments: ['大型鏡', 'モニター', 'リノリウム', '撮影用ライト', 'レッスン用バー', 'スピーカー(Bluetooth©︎対応)'],
        size: '高さ：3.3m　　広さ：56.6m²(7.5m x 7.5m)',
        priceLabel: '30分料金',
        price: '1,000円（税込）',
        images: [
            { src: '/images/studio1-min.jpg', alt: 'スタジオ全景' },
            { src: '/images/studio2-min.jpg', alt: 'スタジオの大型鏡とレッスン用バー' },
            { src: '/images/studio3-min.jpg', alt: 'スタジオの窓側' },
        ],
    },
    {
        name: 'Meeting Room',
        equipments: ['机', '冷蔵庫', '給湯室', '椅子4脚', 'モニター', '電子レンジ'],
        priceLabel: '30分料金',
        price: '500円（税込）',
        images: [
            { src: '/images/meeting-room1-min.jpg', alt: 'ミーティングルームの机と椅子' },
            { src: '/images/meeting-room2-min.jpg', alt: 'ミーティングルームのモニター' },
            { src: '/images/meeting-room3-min.jpg', alt: 'ミーティングルームの給湯室' },
        ],
    },
    {
        name: 'Locker Room',
        equipments: ['鍵付きロッカー', 'シャワールーム（女性用更衣室）'],
        priceLabel: '料金',
        price: '無料',
        images: [
            { src: '/images/locker-room1-min.jpg', alt: '鍵付きロッカー' },
            { src: '/images/locker-room2-min.jpg', alt: 'ロッカールームの様子' },
            { src: '/images/locker-room3-min.jpg', alt: 'シャワールーム' },
        ],
    },
]

const Rooms = () => {
    return (
        <div id='rooms' className='section'>
            <Headline
                title={'Rooms'}
                subTitle={'お部屋について'}
            />
            <div className='room-list'>
                {ROOMS.map((room, index) => (
                    <Room key={room.name} {...room} reverse={index % 2 === 1} />
                ))}
            </div>
        </div>
    )
}

export default Rooms
